/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface DirectionTerritorialeSearch
 */
export interface DirectionTerritorialeSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof DirectionTerritorialeSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof DirectionTerritorialeSearch
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof DirectionTerritorialeSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DirectionTerritorialeSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DirectionTerritorialeSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DirectionTerritorialeSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DirectionTerritorialeSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DirectionTerritorialeSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DirectionTerritorialeSearch interface.
 */
export function instanceOfDirectionTerritorialeSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DirectionTerritorialeSearchFromJSON(json: any): DirectionTerritorialeSearch {
    return DirectionTerritorialeSearchFromJSONTyped(json, false);
}

export function DirectionTerritorialeSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectionTerritorialeSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DirectionTerritorialeSearchToJSON(value?: DirectionTerritorialeSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'actif': BooleanSearchToJSON(value.actif),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

